import type { IconData } from '@stacksjs/iconify-core'

export const basicArrowsUpCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8m8-4.5l4 4h-2v4H6v-4H4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicArrowsUpCircle
